export default __webpack_public_path__ + "static/media/cubyts-whole-dark-no-bg.fc5b7c81.svg";